<div style="display: flex; align-items: center" class="groupTags">
    <button mat-icon-button [matMenuTriggerFor]="menu" color="primary" (click)="$event.stopPropagation()">
        <mat-icon>add_box</mat-icon>
    </button>

    <mat-chip-list>
        <mat-chip
            *ngFor="let group of groupsControl.value"
            disableRipple
            class="groupChip-default"
            [removable]="true"
            (removed)="onGroupRemoved(group)"
        >
            {{ group.groupName }}
            <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
    </mat-chip-list>

    <mat-menu #menu="matMenu">
        <mat-selection-list
            #groupList
            [compareWith]="compare"
            [formControl]="groupsControl"
            (click)="$event.stopPropagation()"
            (selectionChange)="$event ? updateGroupTags($event) : null"
        >
            <mat-list-option *ngFor="let group of groups" [value]="group">
                {{ group.groupName }}
            </mat-list-option>
        </mat-selection-list>
    </mat-menu>
</div>
